import gql from 'graphql-tag';
import { apollo } from 'src/features';
import getCaseById from 'api/getCaseById';

const mutation = gql`
mutation UpdateActivityCase($activityId: ID!, $caseId: Int!) {
  changeActivityCase(activityId: $activityId, caseId: $caseId)
}`;

function updateActivityCase(activityId, caseId) {
  const updateActivity = apollo.client.mutate({
    variables: {
      activityId,
      caseId: parseInt(caseId, 10),
    },
    mutation,
  }).then((res) => res.data.changeActivityCase);

  const getCase = getCaseById(caseId);

  return Promise.all([updateActivity, getCase])
    .then(([status, info]) => {
      if (status) {
        return {
          id: activityId,
          case: {
            id: info.id,
            name: info.name,
            description: info.description,
            insertedAt: new Date(info.insertedAt),
            updatedAt: new Date(info.updatedAt),
            comment: info.comment,
          },
        };
      }
      throw [status, info];
    });
}

export default updateActivityCase;
